module.exports = __webpack_public_path__ + "images/emoji/suspect.db65956050a52b22a9f5.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/suspect.png
// module id = MuQ9
// module chunks = 14